import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "top-bar" }
const _hoisted_3 = { class: "welcome" }
const _hoisted_4 = { class: "content-area" }
const _hoisted_5 = { class: "card-container" }
const _hoisted_6 = { class: "role-card" }
const _hoisted_7 = { class: "card-content" }
const _hoisted_8 = { class: "menu-icon" }
const _hoisted_9 = { class: "menu-title" }

import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { useAuthStore } from '@/store/auth';
  import { useGlobalMenu } from '@/composables/useGlobalMenu';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

  const authStore = useAuthStore();
  const router = useRouter();
  const { entries } = useGlobalMenu();

  const visibleEntries = computed(() => entries.value);

  const welcomeText = computed(() => {
    const displayName = authStore.user?.displayName || authStore.user?.username || '员工';
    return `${displayName}，欢迎使用`;
  });

  const handleLogout = async (): Promise<void> => {
    await authStore.logout();
    await router.replace('/login');
  };

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(welcomeText.value), 1),
      _createElementVNode("button", {
        class: "logout-btn",
        onClick: handleLogout
      }, "退出登录")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "header-section" }, [
        _createElementVNode("h1", { class: "main-title" }, "餐厅系统")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "card-title" }, "请选择功能", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleEntries.value, (entry) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: entry.name,
                to: entry.path,
                class: "menu-card"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(entry.icon), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(entry.title), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "menu-desc" }, "点击进入", -1))
                ]),
                _: 2,
                __: [0]
              }, 1032, ["to"]))
            }), 128))
          ])
        ])
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "footer" }, [
      _createElementVNode("p", null, "© 2025 点餐系统 v1.0")
    ], -1))
  ]))
}
}

})